module.exports = __webpack_public_path__ + "ded0bb11d6f52553ccd1eb910c8030a3.pdf";